import { render, staticRenderFns } from "./LinkRotatorClickHistoryTable.vue?vue&type=template&id=08d5fd4e&scoped=true&"
import script from "./LinkRotatorClickHistoryTable.vue?vue&type=script&lang=js&"
export * from "./LinkRotatorClickHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./LinkRotatorClickHistoryTable.vue?vue&type=style&index=0&id=08d5fd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d5fd4e",
  null
  
)

export default component.exports